import React from 'react';
import PropTypes from 'prop-types';
import PrepareTrackingDataHelper from '@Services/PrepareTrackingDataHelper';
import { ButtonWithIcon } from '@els/els-react--button';

function ToggleButton({
  className,
  ariaControls,
  expanded,
  toggleExpand,
  expandedLabel,
  collapsedLabel,
  prepareTrackingData,
  dataTrackingAction,
  isViewPreview,
}) {
  const getTrackingAttrs = () =>
    prepareTrackingData
      ? {
          'data-click-delegation': 'true',
          'data-tracking': expanded,
          'data-tracking-context': 'reactions',
          'data-tracking-preview': isViewPreview,
          'data-tracking-type': 'contentview,contentlinkclick',
          'data-tracking-action': dataTrackingAction,
          ...PrepareTrackingDataHelper.prepare(prepareTrackingData),
        }
      : {};

  return (
    <ButtonWithIcon
      type="link"
      sprite={expanded ? 'ChevronUp' : 'ChevronDown'}
      iconRight
      linkIconSize="xs"
      size="small"
      className={className}
      onClick={() => toggleExpand()}
      aria-controls={ariaControls}
      aria-expanded={expanded}
      {...getTrackingAttrs()}>
      {expanded ? expandedLabel : collapsedLabel}
    </ButtonWithIcon>
  );
}

ToggleButton.propTypes = {
  className: PropTypes.string,
  ariaControls: PropTypes.string.isRequired,
  expanded: PropTypes.bool.isRequired,
  toggleExpand: PropTypes.func.isRequired,
  expandedLabel: PropTypes.string.isRequired,
  collapsedLabel: PropTypes.string.isRequired,
  prepareTrackingData: PropTypes.object,
  dataTrackingAction: PropTypes.string,
  isViewPreview: PropTypes.bool,
};

export default ToggleButton;
